import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../lib/requireAuth.jsx';
import withRouterParams from '../lib/withRouterParams.jsx';

import ChangeImpactReportsContainer from '../containers/reports/ChangeImpactReportsContainer.jsx';
import { splitAndMapArrayParam } from './utils/index.js';

const ChangeImpactReports = ({ query, slug }) => (
  <>
    <Helmet>
      <title>Change Impact Reports| ChangeSync</title>
    </Helmet>
    <ChangeImpactReportsContainer query={query} slug={slug} />
  </>
);

ChangeImpactReports.getInitialProps = ({ query }) => ({
  slug: query.slug,
  query: {
    // Project filters
    parentPortfolioIds: splitAndMapArrayParam(query.parentPortfolioIds, Number),
    portfolioIds: splitAndMapArrayParam(query.portfolioIds, Number),
    projectsIds: splitAndMapArrayParam(query.projectsIds, Number),

    // Change Impact filters
    startDate: query.startDate,
    endDate: query.endDate,
    ownerIds: splitAndMapArrayParam(query.ownerIds, Number),
    title: query.title,
    changeImpactTypeIds: splitAndMapArrayParam(
      query.changeImpactTypeIds,
      Number
    ),
    scale: splitAndMapArrayParam(query.scale),
    perceptions: splitAndMapArrayParam(query.perceptions),
    peopleImpacted: query.peopleImpacted,
    actionPlanStatuses: splitAndMapArrayParam(query.actionPlanStatuses),
    actionPlanTypes: splitAndMapArrayParam(query.actionPlanTypes),
    taskIds: splitAndMapArrayParam(query.taskIds, Number),
    taskStatuses: splitAndMapArrayParam(query.taskStatuses),
    taskOwnerIds: splitAndMapArrayParam(query.taskOwnerIds, Number),

    // Who is Impacted filters
    impactedGroupsIds: splitAndMapArrayParam(query.impactedGroupsIds, Number),
    impactedEmployeesIds: splitAndMapArrayParam(
      query.impactedEmployeesIds,
      Number
    ),
    impactedExternalEntitiesIds: splitAndMapArrayParam(
      query.impactedExternalEntitiesIds,
      Number
    ),
    organizationStakeholderIds: splitAndMapArrayParam(
      query.organizationStakeholderIds,
      Number
    ),
  },
});

export default requireAuth(withRouterParams(ChangeImpactReports));
